import styled from 'styled-components';
import { colors } from '../../assets/variables';

const Card = styled.div``;

const RoomTypeText = styled.p`
  padding-bottom: 16px;
  text-align: right;

  color: ${colors.baseDark};
  span {
    text-transform: capitalize;
    font-weight: 600;
    color: ${colors.primary};
  }
`;

export default { Card, RoomTypeText };
